<template>
    <v-container class="my-5">
      <!--  Dialogo para mostrar Detalles del Reporte   -->
      <v-dialog v-model="dialogView" scrollable max-width="760">
        <v-card class="report-dialog">
          <v-toolbar dark flat :color="itemDetail.status === 1 ? 'orange darken-2' : 'primary'">
            <v-toolbar-title class="report-dialog__title">
              <v-icon left>{{ itemDetail.status === 1 ? 'mdi-clock-outline' : 'mdi-check-circle-outline' }}</v-icon>
              {{ itemDetail.status === 1 ? $t('in_progress') : $t('done') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                class="align-self-end"
                color="red"
                icon
                @click="dialogView = false"
            ><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-6">
            <div class="detail-heading">
              <v-chip small label color="blue" text-color="white">
                <v-icon left small>mdi-label-outline</v-icon>
                {{ itemDetail.report_type_name }}
              </v-chip>
              <h2>{{ itemDetail.housing_unit_name }}</h2>
              <p><v-icon small>mdi-map-marker-outline</v-icon>{{ itemDetail.house_address }}</p>
            </div>
            <v-row class="detail-metadata">
              <v-col cols="6">
                <span>{{$t('creation_date')}}</span>
                <strong>{{ formatDate(itemDetail.creation_date) }}</strong>
              </v-col>
              <v-col cols="6">
                <span>{{$t('finish_date')}}</span>
                <strong>{{ itemDetail.status === 1 ? $t('in_progress') : formatDate(itemDetail.finish_date) }}</strong>
              </v-col>
            </v-row>
            <section class="detail-section">
              <div class="detail-section__label"><v-icon small>mdi-comment-text-outline</v-icon>{{$t('comments')}}</div>
              <p>{{ itemDetail.comments || $t('no_comment') }}</p>
            </section>
            <section v-if="itemDetail.resident_file" class="detail-section">
              <div class="detail-section__label"><v-icon small>mdi-paperclip</v-icon>{{$t('file')}}</div>
              <v-img
                  v-if="extensionImage(itemDetail.resident_file)"
                  :src="itemDetail.resident_file"
                  class="detail-image"
                  max-height="330"
                  contain
              ></v-img>
              <v-btn v-else text color="primary" @click="newPage(itemDetail.resident_file)">
                <v-icon left>mdi-file-document-outline</v-icon>{{$t('descargar')}}
              </v-btn>
            </section>
          </v-card-text>
          <v-card-actions v-show="itemDetail.status === 1" class="report-dialog__actions px-6 pb-5">
            <v-btn
                @click="newPage(itemDetail.resident_file)"
                v-if="itemDetail.resident_file && extensionImage(itemDetail.resident_file) === true"
                color="primary"
                text>
              <v-icon left>mdi-file-image</v-icon>{{$t('descargar')}}
            </v-btn>
            <v-btn
                @click="newPage(itemDetail.resident_file)"
                v-else-if="itemDetail.resident_file && extensionImage(itemDetail.resident_file) === false"
                color="primary"
                text>
              <v-icon left>mdi-file-pdf-box</v-icon>{{$t('descargar')}}
            </v-btn>
            <v-btn
                v-show="itemDetail.status !== 2 && canManageOwnReports"
                color="grey darken-1"
                outlined
                @click="editReport(itemDetail)"
            >
              <v-icon left>mdi-pencil</v-icon>
              {{$t('change')}}
            </v-btn>
            <v-btn
                v-show="getProfile.role === 1"
                color="red"
                outlined
                @click="deleteDialog = true, idNoticeDelete = itemDetail.id"
            >
              <v-icon>
                mdi-delete
              </v-icon>
              {{$t('delete')}}
            </v-btn>
            <v-btn
                v-show="itemDetail.status === 1 && getProfile.role === 1"
                color="primary"
                @click="idUpdate = itemDetail.id, changeFinish = false, comments_manager = '', finishDialog = true"
                text-color="black"
            > <v-icon>
                mdi-check
              </v-icon>
              Marcar como Hecho
            </v-btn>
          </v-card-actions>
          <v-card-actions v-show="itemDetail.status === 2" class="report-dialog__evidence px-6">
            <v-btn
                color="primary"
                text
            >
              {{$t('evidence')}}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                icon
                @click="show = !show"
            >
              <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-card-text class="px-6 pb-6">
            <v-expand-transition v-show="itemDetail.status === 2">
              <div v-show="show" class="administrator-evidence">
                <v-divider class="mb-5"></v-divider>
                <div class="detail-section">
                  <div class="detail-section__label"><v-icon small>mdi-account-check-outline</v-icon>{{$t('administrator_comments')}}</div>
                  <p>{{(itemDetail.comments_manager === null || itemDetail.comments_manager === '') ? $t('no_comment') : itemDetail.comments_manager}}</p>
                </div>
                <div v-if="itemDetail.administrator_file && extensionImage(itemDetail.administrator_file) === true">
                  <v-img
                      :src="itemDetail.administrator_file"
                      class="detail-image"
                      max-height="330"
                      contain
                  ></v-img>
                </div>
                <div v-else>
                  <h4>{{$t('no_vidence')}}</h4>
                </div>
              </div>
            </v-expand-transition>
          </v-card-text>
        </v-card>
      </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Reporte     -->
        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_report')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            :loading="loading"
                            color="primary"
                            @click="deleteNotice()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="finishDialog" max-width="560">
          <v-card class="report-dialog evidence-dialog">
            <v-toolbar dark flat color="primary">
              <v-toolbar-title class="report-dialog__title">
                <v-icon left>mdi-check-circle-outline</v-icon>
                Marcar como hecho
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="clear(), finishDialog = false"
              ><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="pa-6">
              <div class="evidence-dialog__intro">
                <v-avatar size="42" tile color="green lighten-5">
                  <v-icon color="primary">mdi-clipboard-check-outline</v-icon>
                </v-avatar>
                <div>
                  <strong>{{ itemDetail.housing_unit_name }}</strong>
                  <span>{{ itemDetail.report_type_name }}</span>
                </div>
              </div>
              <p class="evidence-dialog__message">{{$t('msg_evidence')}}</p>
              <v-textarea
                  v-model="comments_manager"
                  name="comments_manager"
                  counter
                  outlined
                  maxlength="300"
                  prepend-icon="mdi-comment-edit"
                  :label="$t('administrator_comments')"
                  :error-messages="errores.comments_manager"
              ></v-textarea>
              <div class="form-attachment evidence-dialog__attachment">
                <div>
                  <div class="detail-section__label"><v-icon small>mdi-camera-outline</v-icon>{{$t('evidence')}}</div>
                  <p>Agrega una imagen que compruebe la atención del reporte.</p>
                </div>
                <v-switch
                    v-model="changeFinish"
                    name="changeFinish"
                    hide-details
                    inset
                ></v-switch>
              </div>
              <v-expand-transition>
                <v-file-input
                    v-show="changeFinish"
                    v-model="administrator_file"
                    :disabled="!changeFinish"
                    :rules="rules"
                    outlined
                    accept="image/png, image/jpeg"
                    placeholder="image"
                    prepend-icon="mdi-paperclip"
                    @change="oversized_function2"
                    :error-messages="errores.administrator_file"
                    :label="$t('file')"
                ></v-file-input>
              </v-expand-transition>
            </v-card-text>
            <v-card-actions class="report-dialog__actions px-6 pb-5">
              <v-btn text color="primary" @click="clear(), finishDialog = false">{{$t('cerrar')}}</v-btn>
              <v-spacer/>
              <v-btn :loading="loading" :disabled="oversized" color="primary" @click="updateStatusReport">
                <v-icon left>mdi-check</v-icon>{{$t('aceptar')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-sheet class="reports-panel" outlined>
          <div class="reports-header">
          <div>
            <div class="reports-eyebrow">{{$t('Reports')}}</div>
            <h1 class="reports-title">{{$t('Reports')}}</h1>
            <p class="reports-subtitle">{{ roleSummary }}</p>
          </div>
          <v-dialog v-model="dialog" persistent scrollable max-width="450">
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="canManageOwnReports"
                color="primary"
                elevation="0"
                v-on="on"
                @click="change = false, update = false, cleanFields()"
              >
                <v-icon left>mdi-plus</v-icon>
                {{$t('add_report')}}
              </v-btn>
            </template>
                <v-form
                        @submit.prevent="update
                            ? updateReport(idUpdate)
                            : addReport()"
                >
                    <v-card class="report-dialog report-form-dialog">
                      <v-toolbar dark flat color="primary">
                        <v-toolbar-title class="report-dialog__title">
                          <v-icon left>{{ update ? 'mdi-pencil-outline' : 'mdi-plus-circle-outline' }}</v-icon>
                          {{ update ? $t('modificar') : $t('add_report') }}
                        </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false"
                            ><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text class="pa-6">
                          <p class="form-intro">{{ update ? $t('msg_report_updated') : $t('add_report') }}</p>
                            <v-autocomplete
                              autofocus
                                    v-model="idTypeReport"
                                    prepend-icon="mdi-alert"
                                    name="idTypeReport"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('type_reports')"
                                    :placeholder="$t('choose_category')"
                                    :error-messages="errores.idTypeReport"
                                    :items="typeReports"
                                    no-data-text="Ningún Resultado"
                                    outlined
                                    clearable
                                    autocomplete="off"
                            >
                            </v-autocomplete>
                            <v-textarea
                                    v-model="comments"
                                    name="comments"
                                    counter
                                    outlined
                                    maxlength="300"
                                    prepend-icon="mdi-comment-edit"
                                    :label="$t('comments')"
                                    :error-messages="errores.comments"
                            ></v-textarea>
                            <div class="form-attachment">
                              <div>
                                <div class="detail-section__label"><v-icon small>mdi-paperclip</v-icon>{{$t('file')}}</div>
                                <p>Adjunta una imagen para complementar el reporte.</p>
                              </div>
                              <v-switch
                                  v-model="change"
                                  name="change"
                                  hide-details
                                  inset
                              ></v-switch>
                            </div>
                            <v-expand-transition>
                              <v-file-input
                                  v-show="change"
                                  v-model="resident_file"
                                  :disabled="!change"
                                  :rules="rules"
                                  outlined
                                  accept="image/png, image/jpeg"
                                  placeholder="image"
                                  prepend-icon="mdi-paperclip"
                                  @change="oversized_function"
                                  :error-messages="errores.resident_file"
                                  :label="$t('file')"
                              ></v-file-input>
                            </v-expand-transition>
                        </v-card-text>
                        <v-card-actions class="report-dialog__actions px-6 pb-5">
                            <v-btn text color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn v-if="update" :disabled="oversized" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                            <v-btn v-else :loading="loading" :disabled="oversized" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
          </div>

          <v-row class="reports-metrics">
            <v-col cols="12" sm="4">
              <div class="report-metric">
                <v-icon color="primary">mdi-clipboard-text-outline</v-icon>
                <div><strong>{{ reports.length }}</strong><span>{{$t('Reports')}}</span></div>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="report-metric report-metric--pending">
                <v-icon color="orange darken-2">mdi-clock-outline</v-icon>
                <div><strong>{{ pendingReports }}</strong><span>{{$t('in_progress')}}</span></div>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="report-metric report-metric--done">
                <v-icon color="primary">mdi-check-circle-outline</v-icon>
                <div><strong>{{ completedReports }}</strong><span>{{$t('done')}}</span></div>
              </div>
            </v-col>
          </v-row>

          <div class="reports-controls">
            <v-text-field
                v-model="search"
                class="reports-search"
                dense
                hide-details
                outlined
                clearable
                prepend-inner-icon="mdi-magnify"
                :label="$t('Buscar')"
            ></v-text-field>
            <v-btn-toggle v-model="statusFilter" mandatory color="primary" class="reports-filter">
              <v-btn value="all">{{$t('todos')}}</v-btn>
              <v-btn value="1">{{$t('in_progress')}}</v-btn>
              <v-btn value="2">{{$t('done')}}</v-btn>
            </v-btn-toggle>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="getReports">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Actualizar reportes</span>
            </v-tooltip>
          </div>

          <v-progress-linear v-if="loadingDataReports" indeterminate color="primary"></v-progress-linear>

          <v-row v-if="filteredReports.length" class="reports-list">
              <v-col
                  v-for="report in filteredReports"
                  :key="report.id"
                  cols="12"
                  md="6"
              >
                <v-card class="report-card" outlined @click="viewReport(report)">
                  <v-card-text class="pa-5">
                    <div class="report-card__top">
                      <v-chip small label color="blue" text-color="white">
                        <v-icon left small>mdi-label-outline</v-icon>
                        {{ report.report_type_name }}
                      </v-chip>
                      <v-chip small label :color="report.status === 1 ? 'orange darken-2' : 'primary'" text-color="white">
                        <v-icon left small>{{ report.status === 1 ? 'mdi-clock-outline' : 'mdi-check' }}</v-icon>
                        {{ report.status === 1 ? $t('in_progress') : $t('done') }}
                      </v-chip>
                    </div>
                    <div class="report-card__content">
                      <v-avatar size="46" tile class="report-card__icon">
                        <v-img v-if="report.resident_file && extensionImage(report.resident_file)" :src="report.resident_file"></v-img>
                        <v-icon v-else color="primary">mdi-alert-circle-outline</v-icon>
                      </v-avatar>
                      <div class="report-card__body">
                        <h2>{{ report.housing_unit_name }}</h2>
                        <p class="report-address"><v-icon small>mdi-map-marker-outline</v-icon>{{ report.house_address }}</p>
                        <p class="report-comments">{{ report.comments || $t('no_comment') }}</p>
                      </div>
                    </div>
                    <v-divider class="my-4"></v-divider>
                    <div class="report-card__footer">
                      <span><v-icon small>mdi-calendar-plus</v-icon>{{ formatDate(report.creation_date) }}</span>
                      <span><v-icon small>{{ report.status === 1 ? 'mdi-clock-outline' : 'mdi-calendar-check-outline' }}</v-icon>{{ report.status === 1 ? $t('in_progress') : formatDate(report.finish_date) }}</span>
                      <v-icon color="primary">mdi-chevron-right</v-icon>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
          </v-row>
          <div v-else-if="!loadingDataReports" class="reports-empty">
            <v-icon size="44" color="grey lighten-1">mdi-clipboard-text-search-outline</v-icon>
            <p>{{$t('no_records_yet')}}</p>
          </div>
        </v-sheet>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'reports',
  created () {
    this.getTypeReports()
    this.getReports()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    filteredReports () {
      const search = this.search.trim().toLowerCase()
      return this.reports.filter(report => {
        const matchesStatus = this.statusFilter === 'all' || report.status === Number(this.statusFilter)
        const searchableText = [report.report_type_name, report.housing_unit_name, report.house_address, report.comments]
          .filter(Boolean).join(' ').toLowerCase()
        return matchesStatus && (!search || searchableText.includes(search))
      })
    },
    pendingReports () {
      return this.reports.filter(report => report.status === 1).length
    },
    completedReports () {
      return this.reports.filter(report => report.status === 2).length
    },
    canManageOwnReports () {
      return this.getProfile.role === 2 || this.getProfile.role === 3
    },
    roleSummary () {
      if (this.getProfile.role === 1) return this.$t('Administrador')
      if (this.getProfile.role === 2) return this.$t('residente_principal')
      return this.$t('residente')
    }
  },
  data: () => ({
    dialog: false,
    finishDialog: false,
    idTypeReport: '',
    typeReports: [],
    comments: '',
    comments_manager: '',
    commentsAux: '',
    loadingDataReports: false,
    loading: false,
    reports: [],
    search: '',
    statusFilter: 'all',
    errores: [],
    idUpdate: 0,
    idNoticeDelete: 0,
    deleteDialog: false,
    resident_file: null,
    administrator_file: null,
    update: false,
    change: false,
    changeFinish: false,
    rules: [],
    oversized: false,
    dialogView: false,
    itemDetail: {
      id: '',
      creation_date: '',
      finish_date: '',
      resident_file: '',
      comments: '',
      status: -1,
      housing_unit_name: '',
      house_address: ''
    },
    show: false
  }),
  beforeUpdate () {
    this.rules = [
      value => !value || value.size < 2000000 || this.$t('msg_overflow_file')
    ]
  },
  methods: {
    viewReport (report) {
      this.itemDetail = report
      this.show = false
      this.dialogView = true
    },
    editReport (report) {
      this.fillFields(report)
      this.update = true
      this.dialog = true
      this.change = false
      this.idUpdate = report.id
    },
    formatDate (date) {
      return date ? date.split('-').reverse().join('/') : this.$t('in_progress')
    },
    newPage (url) {
      window.open(url, '_blank')
    },
    oversized_function (value) {
      console.log('Valor Archivo = ', value)
      if (value !== null) {
        if (value.size > 2048 * 1024) {
          this.oversized = true
        } else {
          this.oversized = false
        }
        console.log('ERoores = ', this.errores.resident_file)
        if (this.change === true && this.errores.resident_file) {
          this.errores.resident_file = ''
        }
      } else {
        this.oversized = false
      }
    },
    oversized_function2 (value) {
      console.log('Valor Archivo = ', value)
      if (value !== null) {
        if (value.size > 2048 * 1024) {
          this.oversized = true
        } else {
          this.oversized = false
        }
        console.log('ERoores = ', this.errores.administrator_file)
        if (this.changeFinish === true && this.errores.administrator_file) {
          this.errores.administrator_file = ''
        }
      } else {
        this.oversized = false
      }
    },
    getReports () {
      this.loadingDataReports = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/report_create_get/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.reports = response.data
          this.loadingDataReports = false
        })
        .catch(error => {
          this.loadingDataReports = false
          console.log(error)
        })
    },
    getTypeReports () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/type_report_create_get/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.typeReports = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    addReport () {
      console.log('File = ', this.resident_file)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      bodyFormData.set('idHousingUnit', this.getProfile.idHousingUnit)
      bodyFormData.set('idResident', this.getProfile.id)
      bodyFormData.set('idTypeReport', this.idTypeReport)
      if (this.comments !== '') {
        bodyFormData.set('comments', this.comments)
      }
      if (this.change === true) {
        bodyFormData.append('resident_file', this.resident_file)
      }
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/report_create_get/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_added_report'))
          this.dialog = false
          this.getReports()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    updateReport (id) {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      if (this.comments !== this.commentsAux) {
        bodyFormData.set('comments', this.comments)
      }
      if (this.change === true) {
        bodyFormData.append('resident_file', this.resident_file)
      }
      bodyFormData.set('idTypeReport', this.idTypeReport)
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/report_get_detail_and_update_it/' + id + '/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getReports()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_report_updated'))
          this.dialog = false
          this.dialogView = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    updateStatusReport () {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()

      bodyFormData.set('status', 2)
      bodyFormData.set('comments_manager', this.comments_manager)
      bodyFormData.set('finish_date', new Date().toISOString().substr(0, 10))
      if (this.changeFinish === true) {
        bodyFormData.append('administrator_file', this.administrator_file)
      }
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/report_get_detail_and_update_it/' + this.idUpdate + '/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getReports()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_report_updated'))
          this.finishDialog = false
          this.dialogView = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    deleteNotice () {
      this.loading = true
      const config = {
        method: 'delete',
        url: ' https://residencial-services.intrare.app/report_get_detail_and_update_it/' + this.idNoticeDelete + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        this.loading = false
        console.log('Report con ID = ', this.idNoticeDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_report_deleted'))
        this.getReports()
        setTimeout(this.clear, 3000)
        this.dialogView = false
        this.deleteDialog = false
      })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    cleanFields () {
      this.comments = ''
      this.idTypeReport = null
      this.resident_file = null
      this.oversized = false
    },
    fillFields (item) {
      if (item.resident_file !== null) {
        var fileAux = new File(['foo'], item.resident_file)
        this.resident_file = fileAux
      }
      this.comments = item.comments
      this.commentsAux = item.comments
      this.idTypeReport = item.idTypeReport
      this.oversized = false
    },
    clear: function () {
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    changeStatus () {
      console.log('changeStatus')
    },
    extensionImage (url) {
      if (url.includes('.png') || url.includes('.gif') || url.includes('.jpeg') || url.includes('.jpg')) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.reports-panel {
  border-color: #dce6dc !important;
  background: #ffffff;
  padding: 28px;
}

.reports-header,
.reports-controls,
.report-card__top,
.report-card__content,
.report-card__footer,
.report-metric {
  display: flex;
  align-items: center;
}

.reports-header {
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5ece5;
}

.reports-eyebrow {
  color: #388e3c;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.reports-title {
  margin: 4px 0;
  color: #263238;
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: 0;
}

.reports-subtitle {
  margin: 0;
  color: #718078;
  font-size: 0.9rem;
}

.reports-metrics {
  margin: 18px -12px 10px;
}

.report-metric {
  gap: 12px;
  min-height: 72px;
  padding: 13px 16px;
  border-left: 3px solid #43a047;
  background: #f7faf7;
}

.report-metric--pending {
  border-left-color: #f57c00;
}

.report-metric strong,
.report-metric span {
  display: block;
  line-height: 1.25;
}

.report-metric strong {
  color: #263238;
  font-size: 1.35rem;
}

.report-metric span {
  color: #718078;
  font-size: 0.8rem;
}

.reports-controls {
  gap: 12px;
  margin: 18px 0 4px;
}

.reports-search {
  max-width: 360px;
}

.reports-filter {
  flex: 1 1 auto;
}

.reports-filter .v-btn {
  min-width: 0;
  font-size: 0.75rem;
  letter-spacing: 0;
}

.reports-list {
  margin-top: 10px;
}

.report-card {
  min-height: 230px;
  border-color: #dfe7df !important;
  cursor: pointer;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.report-card:hover {
  border-color: #43a047 !important;
  box-shadow: 0 8px 20px rgba(38, 50, 56, 0.1);
}

.report-card__top {
  justify-content: space-between;
  gap: 8px;
}

.report-card__content {
  align-items: flex-start;
  gap: 14px;
  margin-top: 20px;
}

.report-card__icon {
  flex: 0 0 auto;
  background: #edf5ed;
}

.report-card__body {
  min-width: 0;
}

.report-card__body h2 {
  overflow: hidden;
  margin: 0;
  color: #263238;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-address,
.report-comments {
  margin: 5px 0 0;
  color: #718078;
  font-size: 0.85rem;
}

.report-address {
  display: flex;
  align-items: center;
  gap: 4px;
}

.report-comments {
  color: #455a64;
  line-height: 1.4;
}

.report-card__footer {
  justify-content: space-between;
  gap: 8px;
  color: #718078;
  font-size: 0.75rem;
}

.report-card__footer span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.reports-empty {
  padding: 56px 16px;
  color: #718078;
  text-align: center;
}

.reports-empty p {
  margin: 10px 0 0;
}

.report-dialog {
  overflow: hidden;
}

.report-dialog__title {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 700;
}

.detail-heading {
  padding-bottom: 20px;
}

.detail-heading h2 {
  margin: 12px 0 5px;
  color: #263238;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0;
}

.detail-heading p {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  color: #718078;
  font-size: 0.9rem;
}

.detail-metadata {
  margin: 0 -12px 20px;
  background: #f7faf7;
}

.detail-metadata .v-col {
  padding: 14px 20px;
}

.detail-metadata .v-col + .v-col {
  border-left: 1px solid #e1eae1;
}

.detail-metadata span,
.detail-metadata strong {
  display: block;
}

.detail-metadata span,
.detail-section__label {
  color: #718078;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.detail-metadata strong {
  margin-top: 4px;
  color: #263238;
  font-size: 0.9rem;
}

.detail-section {
  margin-top: 20px;
}

.detail-section__label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.detail-section p,
.form-attachment p {
  margin: 8px 0 0;
  color: #455a64;
  font-size: 0.9rem;
  line-height: 1.55;
  white-space: pre-line;
}

.detail-image {
  margin-top: 12px;
  border: 1px solid #dfe7df;
  background: #f7faf7;
}

.report-dialog__actions {
  flex-wrap: wrap;
  gap: 8px;
}

.report-dialog__evidence {
  border-top: 1px solid #e5ece5;
}

.administrator-evidence {
  padding-top: 4px;
}

.form-intro {
  margin: 0 0 22px;
  color: #718078;
  font-size: 0.9rem;
}

.form-attachment {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 2px 0 14px;
  padding: 14px 16px;
  border-left: 3px solid #43a047;
  background: #f7faf7;
}

.form-attachment .v-input--switch {
  flex: 0 0 auto;
  margin-top: 0;
  padding-top: 0;
}

.evidence-dialog__intro {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-left: 3px solid #43a047;
  background: #f7faf7;
}

.evidence-dialog__intro strong,
.evidence-dialog__intro span {
  display: block;
}

.evidence-dialog__intro strong {
  color: #263238;
  font-size: 0.95rem;
}

.evidence-dialog__intro span {
  margin-top: 2px;
  color: #718078;
  font-size: 0.8rem;
}

.evidence-dialog__message {
  margin: 18px 0 20px;
  color: #455a64;
  font-size: 0.9rem;
  line-height: 1.55;
}

.evidence-dialog__attachment {
  margin-top: 2px;
}

@media (max-width: 600px) {
  .reports-panel {
    padding: 20px 16px;
  }

  .reports-header,
  .reports-controls {
    align-items: stretch;
    flex-direction: column;
  }

  .reports-header .v-btn {
    align-self: flex-start;
  }

  .reports-search {
    max-width: none;
  }

  .reports-filter {
    display: flex;
  }

  .reports-filter .v-btn {
    flex: 1 1 0;
  }

  .reports-controls > .v-btn {
    align-self: flex-end;
  }

  .detail-metadata .v-col {
    padding: 12px;
  }

  .detail-metadata .v-col + .v-col {
    border-left: 0;
  }

  .report-dialog__actions .v-btn {
    flex: 1 1 auto;
  }

  .evidence-dialog__intro {
    align-items: flex-start;
  }
}
</style>
